// extracted by mini-css-extract-plugin
module.exports = {"center":"center-module--center--5bIf7","paddingTop":"center-module--paddingTop--RcQOi"};